import { render, staticRenderFns } from "./Registration_test.vue?vue&type=template&id=ee358ec0&"
import script from "./Registration_test.vue?vue&type=script&lang=js&"
export * from "./Registration_test.vue?vue&type=script&lang=js&"
import style0 from "./Registration_test.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports